import { useEffect, useState } from "react";
import Input from "../../components/InputBox";
import Select from "../../components/SelectInput";
import { getGlobalOptions } from "../../services/auth/selfSignUp";
import { enumGlobalOptionData } from './../../utils/enumGlobalOptionData';
import { convertForSelect } from './../../utils/convertApiData';
import { SelfSignUpFields } from "../../utils/enumSelfSignup";
import { toast } from "../../components/AppToast";

const Identification = ({ formData, setFormData }) => {
    const [industryType, setIndustryType] = useState([]);
    const [docTypeOption, setDocTypeOption] = useState([]);
    const [docFile, setDocFile] = useState(null);
    const [docType, setDocType] = useState("");
    const [documents, setDocuments] = useState(formData?.partner_regDetails || []);

    const getIndustryType = async () => {
        try {
            const data = await getGlobalOptions(enumGlobalOptionData?.INDUS_TYPE);
            setIndustryType(convertForSelect(data));
        } catch (err) {
            toast.error(err);
        }
    }

    const getDocType = async () => {
        try {
            const data = await getGlobalOptions(enumGlobalOptionData.DOC_TYPE);
            setDocTypeOption(convertForSelect(data));
        } catch (err) {
            toast.error(err);
        }
    }

    useEffect(() => {
        getIndustryType();
        getDocType();
    }, []);

    const handleFileChange = (e) => {
        setDocFile(e.target.files[0]);
    };

    const handleDocTypeChange = (e) => {
        setDocType(e.target.value);
    };

    const handleAddDocument = () => {
        if (docFile && docType) {
            const newDoc = { file: docFile, doc_type: docType, name: docFile.name };
            setDocuments([...documents, newDoc]);
            setDocFile(null);
            setDocType("");
        }
    };

    const handleRemoveDocument = (idx) => {
        // setFormData({
        //     ...formData,
        //     partner_regDetails: formData?.partner_regDetails.filter((_, i) => i !== idx)
        // });
        setDocuments(documents.filter((_, i) => i !== idx));
    };

    const onChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    }
    
    return (
        <div className='card_content'>
            <h4>Step 2: Identification</h4>
            <p>Fill all the mandatory fields details here.</p>
            <div className="card_container">
                <Input isRequired className={"input"} label="Organization Name" name={SelfSignUpFields.TENANT_NAME} value={formData?.[SelfSignUpFields.TENANT_NAME]} onChange={onChange} />
                <Select isRequired options={industryType || []} className="select-input" label={"Industry Type"} name={SelfSignUpFields?.INDUSTRY_TYPE} value={formData?.[SelfSignUpFields?.INDUSTRY_TYPE]} onChange={onChange} />
            </div>
            <span className="form_title">Upload Documents</span>
            <div className="d-flex align-items-end justify-content-between">
                <div className="me-3 w-50">
                    <Select
                        options={docTypeOption}
                        label="Select Document Type"
                        className="select-input"
                        name="doc_type"
                        value={docType}
                        onChange={handleDocTypeChange}
                    />
                </div>
                <div className="me-3 w-50">
                    <Input
                        className="input"
                        label="Select Document"
                        name="file"
                        type="file"
                        value={undefined}
                        onChange={handleFileChange}
                    />
                </div>
                <button
                    type="button"
                    className="btn btn-dark"
                    onClick={handleAddDocument}
                    disabled={!docFile || !docType}
                >
                    Add
                </button>
            </div>
            {documents?.length > 0 && (
                <div className="mt-3">
                    <h6>Uploaded Documents</h6>
                    <ul>
                        {documents?.map((doc, idx) => (
                            <li key={idx} className="d-flex align-items-center gap-2">
                                <span>{doc.name} ({doc.doc_type})</span>
                                <button
                                    type="button"
                                    className="btn btn-sm btn-danger"
                                    onClick={() => handleRemoveDocument(idx)}
                                >
                                    Remove
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    )
}

export default Identification;